export const countries = [
    {"value": "US", "code3": "USA", "text": "United States of America", "number": "840"},
    {"value": "AF", "code3": "AFG", "text": "Afghanistan", "number": "004"},
    {"value": "AL", "code3": "ALB", "text": "Albania", "number": "008"},
    {"value": "DZ", "code3": "DZA", "text": "Algeria", "number": "012"},
    {"value": "AS", "code3": "ASM", "text": "American Samoa", "number": "016"},
    {"value": "AD", "code3": "AND", "text": "Andorra", "number": "020"},
    {"value": "AO", "code3": "AGO", "text": "Angola", "number": "024"},
    {"value": "AI", "code3": "AIA", "text": "Anguilla", "number": "660"},
    {"value": "AQ", "code3": "ATA", "text": "Antarctica", "number": "010"},
    {"value": "AG", "code3": "ATG", "text": "Antigua and Barbuda", "number": "028"},
    {"value": "AR", "code3": "ARG", "text": "Argentina", "number": "032"},
    {"value": "AM", "code3": "ARM", "text": "Armenia", "number": "051"},
    {"value": "AW", "code3": "ABW", "text": "Aruba", "number": "533"},
    {"value": "AU", "code3": "AUS", "text": "Australia", "number": "036"},
    {"value": "AT", "code3": "AUT", "text": "Austria", "number": "040"},
    {"value": "AZ", "code3": "AZE", "text": "Azerbaijan", "number": "031"},
    {"value": "BS", "code3": "BHS", "text": "Bahamas (the)", "number": "044"},
    {"value": "BH", "code3": "BHR", "text": "Bahrain", "number": "048"},
    {"value": "BD", "code3": "BGD", "text": "Bangladesh", "number": "050"},
    {"value": "BB", "code3": "BRB", "text": "Barbados", "number": "052"},
    {"value": "BY", "code3": "BLR", "text": "Belarus", "number": "112"},
    {"value": "BE", "code3": "BEL", "text": "Belgium", "number": "056"},
    {"value": "BZ", "code3": "BLZ", "text": "Belize", "number": "084"},
    {"value": "BJ", "code3": "BEN", "text": "Benin", "number": "204"},
    {"value": "BM", "code3": "BMU", "text": "Bermuda", "number": "060"},
    {"value": "BT", "code3": "BTN", "text": "Bhutan", "number": "064"},
    {"value": "BO", "code3": "BOL", "text": "Bolivia (Plurinational State of)", "number": "068"},
    {"value": "BQ", "code3": "BES", "text": "Bonaire, Sint Eustatius and Saba", "number": "535"},
    {"value": "BA", "code3": "BIH", "text": "Bosnia and Herzegovina", "number": "070"},
    {"value": "BW", "code3": "BWA", "text": "Botswana", "number": "072"},
    {"value": "BV", "code3": "BVT", "text": "Bouvet Island", "number": "074"},
    {"value": "BR", "code3": "BRA", "text": "Brazil", "number": "076"},
    {"value": "IO", "code3": "IOT", "text": "British Indian Ocean Territory (the)", "number": "086"},
    {"value": "BN", "code3": "BRN", "text": "Brunei Darussalam", "number": "096"},
    {"value": "BG", "code3": "BGR", "text": "Bulgaria", "number": "100"},
    {"value": "BF", "code3": "BFA", "text": "Burkina Faso", "number": "854"},
    {"value": "BI", "code3": "BDI", "text": "Burundi", "number": "108"},
    {"value": "CV", "code3": "CPV", "text": "Cabo Verde", "number": "132"},
    {"value": "KH", "code3": "KHM", "text": "Cambodia", "number": "116"},
    {"value": "CM", "code3": "CMR", "text": "Cameroon", "number": "120"},
    {"value": "CA", "code3": "CAN", "text": "Canada", "number": "124"},
    {"value": "KY", "code3": "CYM", "text": "Cayman Islands (the)", "number": "136"},
    {"value": "CF", "code3": "CAF", "text": "Central African Republic (the)", "number": "140"},
    {"value": "TD", "code3": "TCD", "text": "Chad", "number": "148"},
    {"value": "CL", "code3": "CHL", "text": "Chile", "number": "152"},
    {"value": "CN", "code3": "CHN", "text": "China", "number": "156"},
    {"value": "CX", "code3": "CXR", "text": "Christmas Island", "number": "162"},
    {"value": "CC", "code3": "CCK", "text": "Cocos (Keeling) Islands (the)", "number": "166"},
    {"value": "CO", "code3": "COL", "text": "Colombia", "number": "170"},
    {"value": "KM", "code3": "COM", "text": "Comoros (the)", "number": "174"},
    {"value": "CD", "code3": "COD", "text": "Congo (the Democratic Republic of the)", "number": "180"},
    {"value": "CG", "code3": "COG", "text": "Congo (the)", "number": "178"},
    {"value": "CK", "code3": "COK", "text": "Cook Islands (the)", "number": "184"},
    {"value": "CR", "code3": "CRI", "text": "Costa Rica", "number": "188"},
    {"value": "HR", "code3": "HRV", "text": "Croatia", "number": "191"},
    {"value": "CU", "code3": "CUB", "text": "Cuba", "number": "192"},
    {"value": "CW", "code3": "CUW", "text": "Curaçao", "number": "531"},
    {"value": "CY", "code3": "CYP", "text": "Cyprus", "number": "196"},
    {"value": "CZ", "code3": "CZE", "text": "Czechia", "number": "203"},
    {"value": "CI", "code3": "CIV", "text": "Côte d'Ivoire", "number": "384"},
    {"value": "DK", "code3": "DNK", "text": "Denmark", "number": "208"},
    {"value": "DJ", "code3": "DJI", "text": "Djibouti", "number": "262"},
    {"value": "DM", "code3": "DMA", "text": "Dominica", "number": "212"},
    {"value": "DO", "code3": "DOM", "text": "Dominican Republic (the)", "number": "214"},
    {"value": "EC", "code3": "ECU", "text": "Ecuador", "number": "218"},
    {"value": "EG", "code3": "EGY", "text": "Egypt", "number": "818"},
    {"value": "SV", "code3": "SLV", "text": "El Salvador", "number": "222"},
    {"value": "GQ", "code3": "GNQ", "text": "Equatorial Guinea", "number": "226"},
    {"value": "ER", "code3": "ERI", "text": "Eritrea", "number": "232"},
    {"value": "EE", "code3": "EST", "text": "Estonia", "number": "233"},
    {"value": "SZ", "code3": "SWZ", "text": "Eswatini", "number": "748"},
    {"value": "ET", "code3": "ETH", "text": "Ethiopia", "number": "231"},
    {"value": "FK", "code3": "FLK", "text": "Falkland Islands (the) [Malvinas]", "number": "238"},
    {"value": "FO", "code3": "FRO", "text": "Faroe Islands (the)", "number": "234"},
    {"value": "FJ", "code3": "FJI", "text": "Fiji", "number": "242"},
    {"value": "FI", "code3": "FIN", "text": "Finland", "number": "246"},
    {"value": "FR", "code3": "FRA", "text": "France", "number": "250"},
    {"value": "GF", "code3": "GUF", "text": "French Guiana", "number": "254"},
    {"value": "PF", "code3": "PYF", "text": "French Polynesia", "number": "258"},
    {"value": "TF", "code3": "ATF", "text": "French Southern Territories (the)", "number": "260"},
    {"value": "GA", "code3": "GAB", "text": "Gabon", "number": "266"},
    {"value": "GM", "code3": "GMB", "text": "Gambia (the)", "number": "270"},
    {"value": "GE", "code3": "GEO", "text": "Georgia", "number": "268"},
    {"value": "DE", "code3": "DEU", "text": "Germany", "number": "276"},
    {"value": "GH", "code3": "GHA", "text": "Ghana", "number": "288"},
    {"value": "GI", "code3": "GIB", "text": "Gibraltar", "number": "292"},
    {"value": "GR", "code3": "GRC", "text": "Greece", "number": "300"},
    {"value": "GL", "code3": "GRL", "text": "Greenland", "number": "304"},
    {"value": "GD", "code3": "GRD", "text": "Grenada", "number": "308"},
    {"value": "GP", "code3": "GLP", "text": "Guadeloupe", "number": "312"},
    {"value": "GU", "code3": "GUM", "text": "Guam", "number": "316"},
    {"value": "GT", "code3": "GTM", "text": "Guatemala", "number": "320"},
    {"value": "GG", "code3": "GGY", "text": "Guernsey", "number": "831"},
    {"value": "GN", "code3": "GIN", "text": "Guinea", "number": "324"},
    {"value": "GW", "code3": "GNB", "text": "Guinea-Bissau", "number": "624"},
    {"value": "GY", "code3": "GUY", "text": "Guyana", "number": "328"},
    {"value": "HT", "code3": "HTI", "text": "Haiti", "number": "332"},
    {"value": "HM", "code3": "HMD", "text": "Heard Island and McDonald Islands", "number": "334"},
    {"value": "VA", "code3": "VAT", "text": "Holy See (the)", "number": "336"},
    {"value": "HN", "code3": "HND", "text": "Honduras", "number": "340"},
    {"value": "HK", "code3": "HKG", "text": "Hong Kong", "number": "344"},
    {"value": "HU", "code3": "HUN", "text": "Hungary", "number": "348"},
    {"value": "IS", "code3": "ISL", "text": "Iceland", "number": "352"},
    {"value": "IN", "code3": "IND", "text": "India", "number": "356"},
    {"value": "ID", "code3": "IDN", "text": "Indonesia", "number": "360"},
    {"value": "IR", "code3": "IRN", "text": "Iran (Islamic Republic of)", "number": "364"},
    {"value": "IQ", "code3": "IRQ", "text": "Iraq", "number": "368"},
    {"value": "IE", "code3": "IRL", "text": "Ireland", "number": "372"},
    {"value": "IM", "code3": "IMN", "text": "Isle of Man", "number": "833"},
    {"value": "IL", "code3": "ISR", "text": "Israel", "number": "376"},
    {"value": "IT", "code3": "ITA", "text": "Italy", "number": "380"},
    {"value": "JM", "code3": "JAM", "text": "Jamaica", "number": "388"},
    {"value": "JP", "code3": "JPN", "text": "Japan", "number": "392"},
    {"value": "JE", "code3": "JEY", "text": "Jersey", "number": "832"},
    {"value": "JO", "code3": "JOR", "text": "Jordan", "number": "400"},
    {"value": "KZ", "code3": "KAZ", "text": "Kazakhstan", "number": "398"},
    {"value": "KE", "code3": "KEN", "text": "Kenya", "number": "404"},
    {"value": "KI", "code3": "KIR", "text": "Kiribati", "number": "296"},
    {"value": "KP", "code3": "PRK", "text": "Korea (the Democratic People's Republic of)", "number": "408"},
    {"value": "KR", "code3": "KOR", "text": "Korea (the Republic of)", "number": "410"},
    {"value": "KW", "code3": "KWT", "text": "Kuwait", "number": "414"},
    {"value": "KG", "code3": "KGZ", "text": "Kyrgyzstan", "number": "417"},
    {"value": "LA", "code3": "LAO", "text": "Lao People's Democratic Republic (the)", "number": "418"},
    {"value": "LV", "code3": "LVA", "text": "Latvia", "number": "428"},
    {"value": "LB", "code3": "LBN", "text": "Lebanon", "number": "422"},
    {"value": "LS", "code3": "LSO", "text": "Lesotho", "number": "426"},
    {"value": "LR", "code3": "LBR", "text": "Liberia", "number": "430"},
    {"value": "LY", "code3": "LBY", "text": "Libya", "number": "434"},
    {"value": "LI", "code3": "LIE", "text": "Liechtenstein", "number": "438"},
    {"value": "LT", "code3": "LTU", "text": "Lithuania", "number": "440"},
    {"value": "LU", "code3": "LUX", "text": "Luxembourg", "number": "442"},
    {"value": "MO", "code3": "MAC", "text": "Macao", "number": "446"},
    {"value": "MG", "code3": "MDG", "text": "Madagascar", "number": "450"},
    {"value": "MW", "code3": "MWI", "text": "Malawi", "number": "454"},
    {"value": "MY", "code3": "MYS", "text": "Malaysia", "number": "458"},
    {"value": "MV", "code3": "MDV", "text": "Maldives", "number": "462"},
    {"value": "ML", "code3": "MLI", "text": "Mali", "number": "466"},
    {"value": "MT", "code3": "MLT", "text": "Malta", "number": "470"},
    {"value": "MH", "code3": "MHL", "text": "Marshall Islands (the)", "number": "584"},
    {"value": "MQ", "code3": "MTQ", "text": "Martinique", "number": "474"},
    {"value": "MR", "code3": "MRT", "text": "Mauritania", "number": "478"},
    {"value": "MU", "code3": "MUS", "text": "Mauritius", "number": "480"},
    {"value": "YT", "code3": "MYT", "text": "Mayotte", "number": "175"},
    {"value": "MX", "code3": "MEX", "text": "Mexico", "number": "484"},
    {"value": "FM", "code3": "FSM", "text": "Micronesia (Federated States of)", "number": "583"},
    {"value": "MD", "code3": "MDA", "text": "Moldova (the Republic of)", "number": "498"},
    {"value": "MC", "code3": "MCO", "text": "Monaco", "number": "492"},
    {"value": "MN", "code3": "MNG", "text": "Mongolia", "number": "496"},
    {"value": "ME", "code3": "MNE", "text": "Montenegro", "number": "499"},
    {"value": "MS", "code3": "MSR", "text": "Montserrat", "number": "500"},
    {"value": "MA", "code3": "MAR", "text": "Morocco", "number": "504"},
    {"value": "MZ", "code3": "MOZ", "text": "Mozambique", "number": "508"},
    {"value": "MM", "code3": "MMR", "text": "Myanmar", "number": "104"},
    {"value": "NA", "code3": "NAM", "text": "Namibia", "number": "516"},
    {"value": "NR", "code3": "NRU", "text": "Nauru", "number": "520"},
    {"value": "NP", "code3": "NPL", "text": "Nepal", "number": "524"},
    {"value": "NL", "code3": "NLD", "text": "Netherlands (the)", "number": "528"},
    {"value": "NC", "code3": "NCL", "text": "New Caledonia", "number": "540"},
    {"value": "NZ", "code3": "NZL", "text": "New Zealand", "number": "554"},
    {"value": "NI", "code3": "NIC", "text": "Nicaragua", "number": "558"},
    {"value": "NE", "code3": "NER", "text": "Niger (the)", "number": "562"},
    {"value": "NG", "code3": "NGA", "text": "Nigeria", "number": "566"},
    {"value": "NU", "code3": "NIU", "text": "Niue", "number": "570"},
    {"value": "NF", "code3": "NFK", "text": "Norfolk Island", "number": "574"},
    {"value": "MP", "code3": "MNP", "text": "Northern Mariana Islands (the)", "number": "580"},
    {"value": "NO", "code3": "NOR", "text": "Norway", "number": "578"},
    {"value": "OM", "code3": "OMN", "text": "Oman", "number": "512"},
    {"value": "PK", "code3": "PAK", "text": "Pakistan", "number": "586"},
    {"value": "PW", "code3": "PLW", "text": "Palau", "number": "585"},
    {"value": "PS", "code3": "PSE", "text": "Palestine, State of", "number": "275"},
    {"value": "PA", "code3": "PAN", "text": "Panama", "number": "591"},
    {"value": "PG", "code3": "PNG", "text": "Papua New Guinea", "number": "598"},
    {"value": "PY", "code3": "PRY", "text": "Paraguay", "number": "600"},
    {"value": "PE", "code3": "PER", "text": "Peru", "number": "604"},
    {"value": "PH", "code3": "PHL", "text": "Philippines (the)", "number": "608"},
    {"value": "PN", "code3": "PCN", "text": "Pitcairn", "number": "612"},
    {"value": "PL", "code3": "POL", "text": "Poland", "number": "616"},
    {"value": "PT", "code3": "PRT", "text": "Portugal", "number": "620"},
    {"value": "PR", "code3": "PRI", "text": "Puerto Rico", "number": "630"},
    {"value": "QA", "code3": "QAT", "text": "Qatar", "number": "634"},
    {"value": "MK", "code3": "MKD", "text": "Republic of North Macedonia", "number": "807"},
    {"value": "RO", "code3": "ROU", "text": "Romania", "number": "642"},
    {"value": "RU", "code3": "RUS", "text": "Russian Federation (the)", "number": "643"},
    {"value": "RW", "code3": "RWA", "text": "Rwanda", "number": "646"},
    {"value": "RE", "code3": "REU", "text": "Réunion", "number": "638"},
    {"value": "BL", "code3": "BLM", "text": "Saint Barthélemy", "number": "652"},
    {"value": "SH", "code3": "SHN", "text": "Saint Helena, Ascension and Tristan da Cunha", "number": "654"},
    {"value": "KN", "code3": "KNA", "text": "Saint Kitts and Nevis", "number": "659"},
    {"value": "LC", "code3": "LCA", "text": "Saint Lucia", "number": "662"},
    {"value": "MF", "code3": "MAF", "text": "Saint Martin (French part)", "number": "663"},
    {"value": "PM", "code3": "SPM", "text": "Saint Pierre and Miquelon", "number": "666"},
    {"value": "VC", "code3": "VCT", "text": "Saint Vincent and the Grenadines", "number": "670"},
    {"value": "WS", "code3": "WSM", "text": "Samoa", "number": "882"},
    {"value": "SM", "code3": "SMR", "text": "San Marino", "number": "674"},
    {"value": "ST", "code3": "STP", "text": "Sao Tome and Principe", "number": "678"},
    {"value": "SA", "code3": "SAU", "text": "Saudi Arabia", "number": "682"},
    {"value": "SN", "code3": "SEN", "text": "Senegal", "number": "686"},
    {"value": "RS", "code3": "SRB", "text": "Serbia", "number": "688"},
    {"value": "SC", "code3": "SYC", "text": "Seychelles", "number": "690"},
    {"value": "SL", "code3": "SLE", "text": "Sierra Leone", "number": "694"},
    {"value": "SG", "code3": "SGP", "text": "Singapore", "number": "702"},
    {"value": "SX", "code3": "SXM", "text": "Sint Maarten (Dutch part)", "number": "534"},
    {"value": "SK", "code3": "SVK", "text": "Slovakia", "number": "703"},
    {"value": "SI", "code3": "SVN", "text": "Slovenia", "number": "705"},
    {"value": "SB", "code3": "SLB", "text": "Solomon Islands", "number": "090"},
    {"value": "SO", "code3": "SOM", "text": "Somalia", "number": "706"},
    {"value": "ZA", "code3": "ZAF", "text": "South Africa", "number": "710"},
    {"value": "GS", "code3": "SGS", "text": "South Georgia and the South Sandwich Islands", "number": "239"},
    {"value": "SS", "code3": "SSD", "text": "South Sudan", "number": "728"},
    {"value": "ES", "code3": "ESP", "text": "Spain", "number": "724"},
    {"value": "LK", "code3": "LKA", "text": "Sri Lanka", "number": "144"},
    {"value": "SD", "code3": "SDN", "text": "Sudan (the)", "number": "729"},
    {"value": "SR", "code3": "SUR", "text": "Suriname", "number": "740"},
    {"value": "SJ", "code3": "SJM", "text": "Svalbard and Jan Mayen", "number": "744"},
    {"value": "SE", "code3": "SWE", "text": "Sweden", "number": "752"},
    {"value": "CH", "code3": "CHE", "text": "Switzerland", "number": "756"},
    {"value": "SY", "code3": "SYR", "text": "Syrian Arab Republic", "number": "760"},
    {"value": "TW", "code3": "TWN", "text": "Taiwan", "number": "158"},
    {"value": "TJ", "code3": "TJK", "text": "Tajikistan", "number": "762"},
    {"value": "TZ", "code3": "TZA", "text": "Tanzania, United Republic of", "number": "834"},
    {"value": "TH", "code3": "THA", "text": "Thailand", "number": "764"},
    {"value": "TL", "code3": "TLS", "text": "Timor-Leste", "number": "626"},
    {"value": "TG", "code3": "TGO", "text": "Togo", "number": "768"},
    {"value": "TK", "code3": "TKL", "text": "Tokelau", "number": "772"},
    {"value": "TO", "code3": "TON", "text": "Tonga", "number": "776"},
    {"value": "TT", "code3": "TTO", "text": "Trinidad and Tobago", "number": "780"},
    {"value": "TN", "code3": "TUN", "text": "Tunisia", "number": "788"},
    {"value": "TR", "code3": "TUR", "text": "Turkey", "number": "792"},
    {"value": "TM", "code3": "TKM", "text": "Turkmenistan", "number": "795"},
    {"value": "TC", "code3": "TCA", "text": "Turks and Caicos Islands (the)", "number": "796"},
    {"value": "TV", "code3": "TUV", "text": "Tuvalu", "number": "798"},
    {"value": "UG", "code3": "UGA", "text": "Uganda", "number": "800"},
    {"value": "UA", "code3": "UKR", "text": "Ukraine", "number": "804"},
    {"value": "AE", "code3": "ARE", "text": "United Arab Emirates (the)", "number": "784"},
    {"value": "GB", "code3": "GBR", "text": "United Kingdom of Great Britain and Northern Ireland (the)", "number": "826"},
    {"value": "UM", "code3": "UMI", "text": "United States Minor Outlying Islands (the)", "number": "581"},
    {"value": "UY", "code3": "URY", "text": "Uruguay", "number": "858"},
    {"value": "UZ", "code3": "UZB", "text": "Uzbekistan", "number": "860"},
    {"value": "VU", "code3": "VUT", "text": "Vanuatu", "number": "548"},
    {"value": "VE", "code3": "VEN", "text": "Venezuela (Bolivarian Republic of)", "number": "862"},
    {"value": "VN", "code3": "VNM", "text": "Viet Nam", "number": "704"},
    {"value": "VG", "code3": "VGB", "text": "Virgin Islands (British)", "number": "092"},
    {"value": "VI", "code3": "VIR", "text": "Virgin Islands (U.S.)", "number": "850"},
    {"value": "WF", "code3": "WLF", "text": "Wallis and Futuna", "number": "876"},
    {"value": "EH", "code3": "ESH", "text": "Western Sahara", "number": "732"},
    {"value": "YE", "code3": "YEM", "text": "Yemen", "number": "887"},
    {"value": "ZM", "code3": "ZMB", "text": "Zambia", "number": "894"},
    {"value": "ZW", "code3": "ZWE", "text": "Zimbabwe", "number": "716"},
    {"value": "AX", "code3": "ALA", "text": "Åland Islands", "number": "248"}
];